import jwt_decode, { JwtPayload } from 'jwt-decode';

export interface JWT_DEcode extends JwtPayload {
  Permission: string[];
  Role: string | string[];
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role':
    | string
    | string[];
  UD: string;
  Id: string;
}
export const decodeToken = (token: string): JWT_DEcode => {
  const decoded: JWT_DEcode = jwt_decode(token || '');

  if (typeof decoded.Permission == 'string') {
    decoded.Permission = (decoded.Permission as string).split(',');
  }

  const role =
    decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];

  if (typeof role === 'string') {
    decoded.Role = [role];
  } else if (typeof role !== 'string' && typeof role !== 'undefined') {
    decoded.Role = role;
  }

  return decoded;
};
